import styled from 'styled-components';

const DivDetailPageFooter = styled.div`
  display: flex;
  flex-direction: row;
`;

export default DivDetailPageFooter;
